import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
//grid
import { AgGridNg2 } from 'ag-grid-angular';

import { Usuario } from '../Models/Usuario';

import { GlobalsService } from '../services/globals.service';
import { UsuarioService } from '../services/usuario.service';


@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrls: ['./usuario.component.css']
})
export class UsuarioComponent implements OnInit {


  public usuario: Usuario = new Usuario();
  public usuarios: Usuario[];

  public modoEdicion: boolean = false;
  public nuevoRegistro: boolean = false;
  public estadoActivo: boolean = false;
  public contrasenaVerifica: string;
  private icons;
  @ViewChild('agGrid') agGrid: AgGridNg2;


  title = 'Usuarios';


  columnDefs = [
    { headerName: 'Nombre', field: 'nombreUsuario', icons: { filter: ' ' } },
    { headerName: 'Identificación', field: 'identificacion', icons: { filter: ' ' } },
    { headerName: 'Tipo Usuario', field: 'tipoUsuario', icons: { filter: ' ' } },
    { headerName: 'Email', field: 'email', icons: { filter: ' ' } },
    { headerName: 'Estado', field: 'estado', icons: { filter: ' ' } }
  ];

  rowData: any[];

  constructor(private usuarioService: UsuarioService, private globalServices: GlobalsService) {

  }

  ngOnInit() {

    this.modoEdicion = false;

    this.CargarUsuarios();

  }

//Carga los usuarios activos de la compañia
  CargarUsuarios() {
    try {

      this.usuarioService.ObtenerUsuarios(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.usuarios = data;
          this.rowData = this.usuarios;

        },
        err => {
          console.clear();
          console.log(err._body);

        });

    } catch (error) {
      console.log("CargarUsuarios: " + error);
    }

  }

//Inseta o actualiza el usuario
  GuardarRegistro() {

    this.usuario.idCompania = this.globalServices.ObtenerCompania();

    if (this.usuario.idUsuario === undefined) {
      this.usuario.idUsuario = UUID.UUID();
    }
    if (this.usuario.estado === undefined) {
      this.usuario.estado = "ACTIVO";
    }

    if ((this.usuario.contrasena === undefined) || (this.usuario.contrasena === "")) {
      swal("Oops!", "Debe ingresar una contraseña!", "error");
      return;

    }

    if (this.usuario.contrasena != this.contrasenaVerifica) {
      swal("Oops!", "La contraseña y su verificación no coinciden!", "error");
      return;
    }

    this.usuario.contrasena = btoa(this.usuario.contrasena);

    this.usuarioService.GuardarRegistro(this.usuario).subscribe(
      data => {

        swal("Registro guardado con éxito!", "", "success");

        this.usuario = new Usuario();
        this.modoEdicion = false;

        this.CargarUsuarios();

      },
      err => {
        console.error(err);
        swal("Hubo un error a la hora de la ejecución", "", "error");
      }

    );



  }

  NuevoRegistro() {
    this.nuevoRegistro = true;
    this.usuario = new Usuario();
    this.modoEdicion = true;
    this.contrasenaVerifica = "";
    this.estadoActivo = false;
  }

  CancelarEdicion() {
    this.usuario = new Usuario();
    this.modoEdicion = false;

  }

  //cuando le da click al row de tabla
  private onCellClicked($event) {
    try {

      console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
      let row = $event.rowIndex;
      let datos = JSON.parse(JSON.stringify($event.data));

      this.nuevoRegistro = false;
      this.usuario = datos;
      let contrasenaEncriptada = atob(this.usuario.contrasena)
      this.usuario.contrasena = contrasenaEncriptada;
      this.contrasenaVerifica = this.usuario.contrasena;
      this.modoEdicion = true;
      this.estadoActivo = true;
    } catch (error) {
      console.log("oncellclick: " + error);
    }
  }


}
